import { render, staticRenderFns } from "./UserSelector.vue?vue&type=template&id=8fe59e4a&scoped=true&"
import script from "./UserSelector.vue?vue&type=script&lang=ts&"
export * from "./UserSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe59e4a",
  null
  
)

export default component.exports